import React from 'react';
import Link from 'next/link';
import { RecommendedCar } from '@/app/utilities/interfaces';
import ImageWrapper from './ImageWrapper';
import { formatPrice } from '@/app/utilities/helper';

interface RecommendedCarItemProps {
    car: RecommendedCar;
    isLast?: boolean;
    showEmiLink?: boolean;
    trackingClass?: string;
}

const RecommendedCarItem: React.FC<RecommendedCarItemProps> = ({ car, showEmiLink = false, trackingClass }) => {
    const imageUrl = car.image || `${process.env.NEXT_PUBLIC_CDN_URL}placeholder-car.webp`;
    const basePrice = car.price_range?.base
        ? String(formatPrice(Number(car.price_range.base), { includeUnit: true }))
        : null;

    const carHref = `/${car?.brand_slug}/${car?.model_slug}`;
    const rowClass = `flex items-center gap-3 py-3 hover:bg-gray-50 px-1 ${trackingClass ?? ''}`;
    const image = (
        <ImageWrapper
            src={imageUrl}
            alt={`Image of ${car.brand_name} ${car.model_name}`}
            width={64}
            height={40}
            className="w-16 h-10 object-cover rounded-md flex-shrink-0"
            loading="lazy"
            title={`${car.brand_name} ${car.model_name}`}
        />
    );

    // When showEmiLink is true an <a> inside the row links to a different page,
    // so the row wrapper must be a div to avoid nested <a> elements.
    if (showEmiLink) {
        return (
            <div className={rowClass}>
                <Link prefetch={false} href={carHref} title={`${car.brand_name} ${car.model_name}`} className={trackingClass ?? ''}>
                    {image}
                </Link>
                <div className="flex-1">
                    <Link prefetch={false} href={carHref} title={`${car.brand_name} ${car.model_name}`} className={`block text-[15px] font-[500] leading-[18px] text-[#1F2A37] ${trackingClass ?? ''}`}>
                        {car.brand_name} {car.model_name}
                    </Link>
                    <div className="text-[13px] leading-[20px] font-bold text-[#1F2A37] mt-1">{basePrice
                        ? <>{basePrice}<span className="text-[11px] text-[#62748E] font-normal ml-0.5"> onwards</span></>
                        : "Price On Request"}</div>
                    <Link
                        prefetch={false}
                        title='Check EMI'
                        href={`/${car.brand_slug}/${car.model_slug}/car-loan-emi-calculator`}
                        className={`text-[12px] font-semibold text-[#008C8B] hover:underline mt-0.5 inline-block ${trackingClass ?? ''}`}
                    >
                        Check EMI
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <Link prefetch={false} href={carHref} title={`${car.brand_name} ${car.model_name}`} className={rowClass}>
            {image}
            <div className="flex-1">
                <div className="text-[15px] font-[500] leading-[18px] text-[#1F2A37]">{car.brand_name} {car.model_name}</div>
                <div className="text-[13px] leading-[20px] font-bold text-[#1F2A37] mt-1">{basePrice
                    ? <>{basePrice}<span className="text-[11px] text-[#62748E] font-normal ml-0.5"> onwards</span></>
                    : "Price On Request"}</div>
            </div>
        </Link>
    );
};

export default RecommendedCarItem;